// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scoreboard-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  color: var(--vb-text);
}

/* ---- Header + tabs as one shell ---- */
.sb-header {
  position: sticky;
  top: 0;
  z-index: 40;
  background: var(--vb-surface);
  border-bottom: 1px solid var(--vb-border);
}

.sb-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  max-width: 960px;
  margin: 0 auto;
  padding: 8px 12px 0;
}

.sb-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.sb-brand h1 {
  margin: 0;
  font-size: 15px;
  font-weight: 750;
  letter-spacing: -0.03em;
  text-align: left;
  text-transform: none;
  color: var(--vb-text);
  background: none;
  -webkit-text-fill-color: unset;
}

.editing-badge {
  display: inline-flex;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: var(--vb-radius-pill);
  background: var(--vb-warning-soft);
  color: var(--vb-warning);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  vertical-align: middle;
}

.sb-actions {
  display: flex;
  gap: 4px;
}

.scoreboard-container .control-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent;
  color: var(--vb-text-muted);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  min-width: 0;
  margin: 0;
}

.scoreboard-container .control-btn:hover {
  background: var(--vb-surface-hover);
  color: var(--vb-text);
}

.guest-offline-notice {
  max-width: 960px;
  margin: 8px auto 0;
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--vb-warning-soft);
  font-size: 13px;
  text-align: center;
}

.sb-nav {
  display: flex;
  gap: 0;
  max-width: 960px;
  margin: 0 auto;
  padding: 0 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.toggle-btn {
  flex: 1 0 auto;
  background: transparent;
  color: var(--vb-text-muted);
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 12px 8px;
  min-height: 0;
  min-width: 0;
  margin: 0;
  border-radius: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 650;
  white-space: nowrap;
}

.toggle-btn:hover { color: var(--vb-text); background: transparent; }

.toggle-btn.active {
  background: transparent;
  color: var(--vb-text);
  border-bottom-color: var(--vb-primary);
}

body.night-mode .toggle-btn.active {
  background: transparent;
  color: var(--vb-text);
}

.main-content {
  flex-grow: 1;
  padding: 12px 10px 28px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.main-content > .statistics,
.main-content > .team-management,
.main-content > .match-grouping,
.main-content > .match-display,
.main-content > .match-group-details,
.main-content > .team-search {
  width: 100%;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}

.main-content:has(> .match-grouping),
.main-content:has(> .match-group-details),
.main-content:has(> .statistics),
.main-content:has(> .team-management),
.main-content:has(> .match-display) {
  padding-left: 8px;
  padding-right: 8px;
}

.game-area {
  width: 100%;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
}

.board-hint {
  margin: 0;
  text-align: center;
  font-size: 13px;
  color: var(--vb-text-muted);
  font-weight: 500;
}

.team-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.team-input-container {
  position: relative;
}

.team-inputs input,
.team-input {
  width: 100%;
  padding: 8px 10px;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid var(--vb-border);
  background: var(--vb-surface);
  color: var(--vb-text);
  font-weight: 650;
}

.team-a-input { border-color: color-mix(in srgb, var(--vb-team-a) 55%, var(--vb-border)); }
.team-b-input { border-color: color-mix(in srgb, var(--vb-team-b) 55%, var(--vb-border)); }

.match-group-selector {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
}

.match-group-select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--vb-border);
  border-radius: 10px;
  font-size: 13px;
  background: var(--vb-surface);
  color: var(--vb-text);
}

.current-match-info {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 13px;
}

.current-match-info strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.live-scoreboard {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.live-scoreboard .team-panel,
.live-scoreboard .team {
  min-height: 148px;
  padding: 28px 10px 40px;
  border-radius: 16px;
}

.live-scoreboard .team-name {
  font-size: 12px;
}

.live-scoreboard .score {
  font-size: clamp(3.6rem, 14vw, 5.4rem);
}

.board-center { display: none; }

.board-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.live-stats {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;
  padding: 6px 10px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 10px;
  color: var(--vb-text-muted);
  font-size: 12px;
  font-weight: 650;
}

.live-stats strong {
  color: var(--vb-text);
  font-size: 16px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.live-stats-split {
  margin-left: auto;
  font-size: 11px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.live-share {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.live-share-start,
.live-share-copy,
.live-share-stop {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 750;
}

.live-share-start {
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border-strong);
  padding: 8px 14px;
}

.live-share-start:disabled {
  opacity: 0.6;
  cursor: default;
}

.live-share-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: var(--vb-radius-pill);
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.live-share-badge::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--vb-danger);
}

.live-share-url {
  flex: 1 1 160px;
  min-width: 0;
  min-height: 40px;
  padding: 8px 10px;
  border: 1px solid var(--vb-border);
  border-radius: 10px;
  background: var(--vb-surface);
  color: var(--vb-text);
  font-size: 13px;
}

.live-share-copy {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  border: none;
  padding: 8px 14px;
}

.live-share-stop {
  background: transparent;
  color: var(--vb-text-muted);
  border: 1px solid var(--vb-border);
  padding: 8px 12px;
}

.timeout-container {
  display: contents;
}

.timeout-team-a,
.timeout-team-b {
  padding: 4px 6px;
  font-size: 11px;
  gap: 6px;
}

.timeout-checkbox {
  width: 28px;
  height: 28px;
}

.score-controls {
  display: flex;
  gap: 6px;
  align-items: center;
}

.score-controls button,
.swap-colors-btn,
.reset-btn {
  min-height: 36px;
  min-width: 36px;
  padding: 6px 10px;
  font-size: 13px;
}

.quiet-details {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 10px;
  padding: 0 12px;
}

.quiet-details summary {
  cursor: pointer;
  list-style: none;
  padding: 10px 0;
  font-size: 13px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.quiet-details summary::-webkit-details-marker { display: none; }
.quiet-details[open] summary { color: var(--vb-text); }
.quiet-details .note-field { padding-bottom: 10px; }

.team-input-container {
  position: relative;
}

.team-inputs input,
.team-input {
  width: 100%;
  padding: 12px 14px;
  font-size: 16px;
  box-sizing: border-box;
  border-radius: var(--vb-radius-sm);
  border: 2px solid var(--vb-border);
  background: var(--vb-surface);
  color: var(--vb-text);
  font-weight: 650;
}

.team-a-input { border-color: var(--vb-team-a); }
.team-b-input { border-color: var(--vb-team-b); }

.team-input:disabled {
  background: var(--vb-surface-2);
  color: var(--vb-text-muted);
  cursor: not-allowed;
}

.team-inputs .suggestions {
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  right: 0;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 0 0 12px 12px;
  z-index: 20;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: var(--vb-shadow);
}

.team-inputs .suggestion-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--vb-border);
  color: var(--vb-text);
  font-size: 14px;
}

.team-inputs .suggestion-item:hover {
  background: var(--vb-surface-hover);
}

.team-inputs .suggestion-item:last-child { border-bottom: none; }

/* Match group */
.match-group-selector {
  background: transparent;
  border: none;
  padding: 0;
  box-shadow: none;
}

.match-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  font-weight: 650;
  font-size: 13px;
  color: var(--vb-text-muted);
}

.current-match-info {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  padding: 6px 10px;
  border-radius: 10px;
  color: var(--vb-text);
  font-size: 13px;
}

.set-number {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  padding: 2px 8px;
  border-radius: var(--vb-radius-pill);
  font-size: 11px;
  font-weight: 800;
}

.clear-match-btn {
  background: transparent;
  color: inherit;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.match-group-select,
.new-match-form input,
.new-match-form select,
.form-row input,
.form-row select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-sm);
  font-size: 14px;
  background: var(--vb-surface);
  color: var(--vb-text);
  box-sizing: border-box;
}

.new-match-form {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--vb-border);
}

.form-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 8px;
  margin-bottom: 10px;
}

.form-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.create-btn,
.cancel-btn {
  border: none;
  padding: 10px 16px;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 14px;
  font-weight: 650;
}

.create-btn { background: var(--vb-success); color: #fff; }
.cancel-btn { background: var(--vb-surface-2); color: var(--vb-text); border: 1px solid var(--vb-border); }

@media (max-width: 768px) {
  .form-row { grid-template-columns: 1fr; }
}

/* Live score panels */
.live-scoreboard-wrap {
  position: relative;
}

.live-scoreboard {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  align-items: stretch;
}

.timeout-clock {
  position: absolute;
  inset: 0;
  z-index: 6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 20px;
  border-radius: var(--vb-radius-lg);
  background: rgba(15, 23, 42, 0.9);
  color: #fff;
  text-align: center;
  box-shadow: var(--vb-shadow-lg);
}

.timeout-clock.team-a {
  background: color-mix(in srgb, var(--vb-team-a) 86%, #0f172a);
}

.timeout-clock.team-b {
  background: color-mix(in srgb, var(--vb-team-b) 86%, #0f172a);
}

.timeout-clock-kicker {
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  opacity: 0.8;
}

.timeout-clock-team {
  display: block;
  margin-top: 2px;
  font-size: 14px;
  font-weight: 700;
}

.timeout-clock-time {
  font-family: var(--vb-font-score);
  font-size: clamp(3.4rem, 16vw, 5.6rem);
  font-weight: 800;
  line-height: 0.9;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.timeout-clock.ending .timeout-clock-time {
  color: #fbbf24;
}

.timeout-clock.expired .timeout-clock-time {
  color: #fbbf24;
  letter-spacing: 0.08em;
}

.timeout-clock-track {
  width: min(72%, 260px);
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
  overflow: hidden;
}

.timeout-clock-fill {
  height: 100%;
  width: 100%;
  transform-origin: left center;
  background: #fff;
  transition: transform 1s linear;
}

.timeout-clock.ending .timeout-clock-fill {
  background: #fbbf24;
}

.timeout-clock-dismiss {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  padding: 8px 14px;
  border: 1.5px solid rgba(255, 255, 255, 0.55);
  border-radius: var(--vb-radius-pill);
  background: rgba(0, 0, 0, 0.28);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.timeout-clock-dismiss:hover {
  background: rgba(0, 0, 0, 0.45);
}

.live-scoreboard .team-panel,
.live-scoreboard .team {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 140px;
  padding: 26px 10px 40px;
  border: none;
  border-radius: var(--vb-radius-lg);
  cursor: pointer;
  color: #fff;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
  touch-action: manipulation;
  box-shadow: var(--vb-shadow);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.live-scoreboard .team-panel:hover,
.live-scoreboard .team:hover {
  transform: translateY(-2px);
  filter: brightness(1.06);
}

.live-scoreboard .team-panel:active,
.live-scoreboard .team:active {
  transform: scale(0.98);
}

.live-scoreboard .team-a {
  background: linear-gradient(165deg, #fb7185 0%, var(--vb-team-a) 45%, var(--vb-team-a-deep) 100%);
}

.live-scoreboard .team-b {
  background: linear-gradient(165deg, #60a5fa 0%, var(--vb-team-b) 45%, var(--vb-team-b-deep) 100%);
}

.serving-chip {
  position: absolute;
  top: 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: var(--vb-radius-pill);
  background: var(--vb-serve);
  color: #0b1d36;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  animation: none;
}

@keyframes serve-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.6); }
  50% { box-shadow: 0 0 0 8px rgba(251, 191, 36, 0); }
}

.live-scoreboard .team-name {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.92;
  text-align: center;
  max-width: 100%;
  word-break: break-word;
}

.live-scoreboard .score {
  font-family: var(--vb-font-score);
  font-size: clamp(3.4rem, 13vw, 5.2rem);
  font-weight: 800;
  line-height: 0.9;
  letter-spacing: -0.04em;
  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.tap-hint {
  margin-top: 8px;
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.75;
}

.board-center {
  display: none;
}

.vs-label {
  font-family: var(--vb-font-score);
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.serve-hint {
  font-size: 10px;
  text-align: center;
  max-width: 64px;
  line-height: 1.3;
}

.serving-indicator {
  display: none;
}

@keyframes flash-team-a {
  0%, 100% { filter: brightness(100%); }
  50% { filter: brightness(130%); }
}
@keyframes flash-team-b {
  0%, 100% { filter: brightness(100%); }
  50% { filter: brightness(125%); }
}

.live-scoreboard .team-a.flash { animation: flash-team-a 0.3s ease-out; }
.live-scoreboard .team-b.flash { animation: flash-team-b 0.3s ease-out; }

.ace-btn {
  position: absolute;
  bottom: 8px;
  z-index: 2;
  min-width: 40px;
  min-height: 26px;
  padding: 3px 8px;
  border: 1.5px solid rgba(255, 255, 255, 0.5);
  border-radius: var(--vb-radius-pill);
  background: rgba(0, 0, 0, 0.32);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  touch-action: manipulation;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.ace-btn-left { left: 8px; }
.ace-btn-right { right: 8px; }

.ace-btn:hover {
  background: rgba(0, 0, 0, 0.5);
  border-color: #fbbf24;
  color: #fbbf24;
}

.ace-btn:active {
  transform: scale(0.94);
  background: #fbbf24;
  border-color: #fbbf24;
  color: #0b1d36;
}

.ace-btn:focus-visible {
  outline: 2px solid #fbbf24;
  outline-offset: 2px;
}

/* Timeouts */
.timeout-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  width: 100%;
}

.timeout-team-a,
.timeout-team-b {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 10px;
  font-size: 11px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.timeout-checkbox {
  position: relative;
  display: inline-block;
  width: 28px;
  height: 28px;
  cursor: pointer;
  flex-shrink: 0;
}

.timeout-checkbox input {
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox-custom {
  position: absolute;
  inset: 0;
  background: var(--vb-surface-2);
  border: 2px solid var(--vb-border-strong);
  border-radius: 10px;
  transition: all 0.2s ease;
}

.timeout-team-a .checkbox-custom { border-color: var(--vb-team-a); }
.timeout-team-b .checkbox-custom { border-color: var(--vb-team-b); }

.timeout-checkbox input:checked + .checkbox-custom::after {
  content: 'T';
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-size: 14px;
  font-weight: 800;
  color: #fff;
}

.timeout-team-a input:checked + .checkbox-custom {
  background: var(--vb-team-a);
  border-color: var(--vb-team-a);
}
.timeout-team-b input:checked + .checkbox-custom {
  background: var(--vb-team-b);
  border-color: var(--vb-team-b);
}

/* Controls */
.score-controls {
  display: flex;
  gap: 6px;
  align-items: center;
}

.score-controls button,
.swap-colors-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 8px 12px;
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-weight: 650;
  font-size: 13px;
}

.score-controls button:hover,
.swap-colors-btn:hover {
  background: var(--vb-surface-hover);
}

.score-controls .button-a,
.score-controls .button-b {
  max-width: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reset-control {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
}

.reset-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  border: 1px solid color-mix(in srgb, var(--vb-danger) 30%, transparent);
  padding: 10px 18px;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
}

.reset-btn:hover { filter: brightness(0.95); }

/* Notes + messages */
.note-field {
  width: 100%;
  max-width: 100%;
}

.note-field textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  background: var(--vb-surface);
  color: var(--vb-text);
  resize: vertical;
  font-size: 16px;
  min-height: 80px;
}

.message-container {
  min-height: 0;
}

.error-message,
.success-message {
  padding: 10px 12px;
  border-radius: var(--vb-radius-sm);
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

.error-message {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
}
.success-message {
  background: var(--vb-success-soft);
  color: var(--vb-success);
}

/* Rally table + chart */
.scoring-order-table {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  padding: 14px;
  box-shadow: var(--vb-shadow-sm);
}

.scoring-order-table h3 {
  text-align: center;
  margin: 0 0 10px;
  font-size: 14px;
  color: var(--vb-text-muted);
}

.scoring-order-table table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.scoring-order-table th,
.scoring-order-table td {
  border: none;
  padding: 8px;
  text-align: center;
  vertical-align: top;
}

.scoring-order-table th {
  background: transparent;
  color: var(--vb-text);
  font-size: 13px;
}

.scoring-order-table td {
  height: auto;
  min-height: 64px;
}

.scoring-order-table .score-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin: 2px;
  border-radius: 8px;
  background: var(--vb-surface-2);
  border: 1px solid var(--vb-border);
  font-size: 12px;
  font-weight: 700;
}

.scoring-order-table .timeout-item {
  background: var(--vb-warning);
  color: #0b1d36;
  border-color: transparent;
}

.scoring-order-table .ace-item {
  min-width: 32px;
  width: auto;
  padding: 0 4px;
  background: #fbbf24;
  color: #0b1d36;
  border-color: transparent;
}

.score-chart {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  padding: 14px;
  box-shadow: var(--vb-shadow-sm);
}

.score-chart h3,
.score-chart h4 {
  text-align: center;
  margin: 0 0 12px;
  font-size: 14px;
  color: var(--vb-text);
}

/* Recent matches */
.recent-matches-container {
  width: 100%;
  max-width: 720px;
  margin: 0 auto 40px;
  padding: 0 12px;
  box-sizing: border-box;
}

.recent-matches {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  padding: 16px;
  box-shadow: var(--vb-shadow-sm);
}

.recent-matches h2 {
  text-align: left;
  text-transform: none;
  letter-spacing: -0.02em;
  font-size: 16px;
  font-weight: 800;
  margin: 0 0 12px;
  color: var(--vb-text);
}

.recent-match-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recent-match-card {
  display: grid;
  grid-template-columns: 88px 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--vb-surface-2);
  border: 1px solid transparent;
}

.recent-match-card:hover {
  border-color: var(--vb-border);
}

.rm-date {
  font-size: 12px;
  color: var(--vb-text-muted);
  font-weight: 600;
}

.rm-teams {
  font-size: 14px;
  color: var(--vb-text);
}

.rm-score {
  font-family: var(--vb-font-score);
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.winner { font-weight: 800; color: var(--vb-primary); }

.recent-matches table {
  width: 100%;
  border-collapse: collapse;
}

.recent-matches th,
.recent-matches td {
  border: none;
  border-bottom: 1px solid var(--vb-border);
  padding: 10px 8px;
  text-align: left;
  color: var(--vb-text);
}

.recent-matches tbody tr:last-child td { border-bottom: none; }
.recent-matches tbody tr:hover { background: var(--vb-surface-hover); }

.recent-matches th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--vb-text-muted);
}

.note-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 768px) {
  .game-area { max-width: 760px; }
  .live-scoreboard .team-panel, .live-scoreboard .team { min-height: 168px; }
  .live-scoreboard .score { font-size: 5.5rem; }
}

@media (max-width: 480px) {
  .live-scoreboard { gap: 6px; }
  .board-center { min-width: 28px; }
  .vs-label { font-size: 14px; }
  .tap-hint { display: none; }
  .team-name { font-size: 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScoreBoard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB,qBAAqB,EAAE,uBAAuB,EAAE;;AAEpE;EACE,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;;;;;EAME,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gBAAgB,wEAAwE,EAAE;AAC1F,gBAAgB,wEAAwE,EAAE;;AAE1F;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,gBAAgB,aAAa,EAAE;;AAE/B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,iDAAiD,aAAa,EAAE;AAChE,+BAA+B,qBAAqB,EAAE;AACtD,6BAA6B,oBAAoB,EAAE;;AAEnD;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gBAAgB,8BAA8B,EAAE;AAChD,gBAAgB,8BAA8B,EAAE;;AAEhD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2CAA2C,mBAAmB,EAAE;;AAEhE,gBAAgB;AAChB;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc,6BAA6B,EAAE,WAAW,EAAE;AAC1D,cAAc,+BAA+B,EAAE,qBAAqB,EAAE,kCAAkC,EAAE;;AAE1G;EACE,YAAY,0BAA0B,EAAE;AAC1C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,6CAA6C;EAC7C,oCAAoC;EACpC,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,0EAA0E;AAC5E;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,wBAAwB,EAAE;AAClC;AACA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,wBAAwB,EAAE;AAClC;;AAEA,iCAAiC,qCAAqC,EAAE;AACxE,iCAAiC,qCAAqC,EAAE;;AAExE;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,oCAAoC;EACpC,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,gBAAgB,SAAS,EAAE;AAC3B,iBAAiB,UAAU,EAAE;;AAE7B;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,yCAAyC;EACzC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,mCAAmC,8BAA8B,EAAE;AACnE,mCAAmC,8BAA8B,EAAE;;AAEnE;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,uBAAuB;EACvB,uEAAuE;EACvE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB,wBAAwB,EAAE;;AAE7C,qBAAqB;AACrB;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,UAAU,gBAAgB,EAAE,wBAAwB,EAAE;;AAEtD;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,yCAAyC,mBAAmB,EAAE;AAC9D,iCAAiC,mCAAmC,EAAE;;AAEtE;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa,gBAAgB,EAAE;EAC/B,uDAAuD,iBAAiB,EAAE;EAC1E,0BAA0B,iBAAiB,EAAE;AAC/C;;AAEA;EACE,mBAAmB,QAAQ,EAAE;EAC7B,gBAAgB,eAAe,EAAE;EACjC,YAAY,eAAe,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,aAAa,eAAe,EAAE;AAChC","sourcesContent":[".scoreboard-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  color: var(--vb-text);\n}\n\n/* ---- Header + tabs as one shell ---- */\n.sb-header {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  background: var(--vb-surface);\n  border-bottom: 1px solid var(--vb-border);\n}\n\n.sb-header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 8px 12px 0;\n}\n\n.sb-brand {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.sb-brand h1 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 750;\n  letter-spacing: -0.03em;\n  text-align: left;\n  text-transform: none;\n  color: var(--vb-text);\n  background: none;\n  -webkit-text-fill-color: unset;\n}\n\n.editing-badge {\n  display: inline-flex;\n  margin-left: 6px;\n  padding: 1px 7px;\n  border-radius: var(--vb-radius-pill);\n  background: var(--vb-warning-soft);\n  color: var(--vb-warning);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n\n.sb-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.scoreboard-container .control-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  background: transparent;\n  color: var(--vb-text-muted);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  min-width: 0;\n  margin: 0;\n}\n\n.scoreboard-container .control-btn:hover {\n  background: var(--vb-surface-hover);\n  color: var(--vb-text);\n}\n\n.guest-offline-notice {\n  max-width: 960px;\n  margin: 8px auto 0;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: var(--vb-warning-soft);\n  font-size: 13px;\n  text-align: center;\n}\n\n.sb-nav {\n  display: flex;\n  gap: 0;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 0 8px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.toggle-btn {\n  flex: 1 0 auto;\n  background: transparent;\n  color: var(--vb-text-muted);\n  border: none;\n  border-bottom: 2px solid transparent;\n  padding: 10px 12px 8px;\n  min-height: 0;\n  min-width: 0;\n  margin: 0;\n  border-radius: 0;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.toggle-btn:hover { color: var(--vb-text); background: transparent; }\n\n.toggle-btn.active {\n  background: transparent;\n  color: var(--vb-text);\n  border-bottom-color: var(--vb-primary);\n}\n\nbody.night-mode .toggle-btn.active {\n  background: transparent;\n  color: var(--vb-text);\n}\n\n.main-content {\n  flex-grow: 1;\n  padding: 12px 10px 28px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.main-content > .statistics,\n.main-content > .team-management,\n.main-content > .match-grouping,\n.main-content > .match-display,\n.main-content > .match-group-details,\n.main-content > .team-search {\n  width: 100%;\n  max-width: 960px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.main-content:has(> .match-grouping),\n.main-content:has(> .match-group-details),\n.main-content:has(> .statistics),\n.main-content:has(> .team-management),\n.main-content:has(> .match-display) {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.game-area {\n  width: 100%;\n  max-width: 640px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 0;\n  background: transparent;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.board-hint {\n  margin: 0;\n  text-align: center;\n  font-size: 13px;\n  color: var(--vb-text-muted);\n  font-weight: 500;\n}\n\n.team-inputs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.team-input-container {\n  position: relative;\n}\n\n.team-inputs input,\n.team-input {\n  width: 100%;\n  padding: 8px 10px;\n  font-size: 15px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  border: 1px solid var(--vb-border);\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-weight: 650;\n}\n\n.team-a-input { border-color: color-mix(in srgb, var(--vb-team-a) 55%, var(--vb-border)); }\n.team-b-input { border-color: color-mix(in srgb, var(--vb-team-b) 55%, var(--vb-border)); }\n\n.match-group-selector {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n}\n\n.match-group-select {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--vb-border);\n  border-radius: 10px;\n  font-size: 13px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n}\n\n.current-match-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  padding: 6px 10px;\n  border-radius: 10px;\n  font-size: 13px;\n}\n\n.current-match-info strong {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.live-scoreboard {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.live-scoreboard .team-panel,\n.live-scoreboard .team {\n  min-height: 148px;\n  padding: 28px 10px 40px;\n  border-radius: 16px;\n}\n\n.live-scoreboard .team-name {\n  font-size: 12px;\n}\n\n.live-scoreboard .score {\n  font-size: clamp(3.6rem, 14vw, 5.4rem);\n}\n\n.board-center { display: none; }\n\n.board-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.live-stats {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px 8px;\n  padding: 6px 10px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 10px;\n  color: var(--vb-text-muted);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.live-stats strong {\n  color: var(--vb-text);\n  font-size: 16px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.live-stats-split {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.live-share {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.live-share-start,\n.live-share-copy,\n.live-share-stop {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 40px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 750;\n}\n\n.live-share-start {\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border-strong);\n  padding: 8px 14px;\n}\n\n.live-share-start:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.live-share-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  border-radius: var(--vb-radius-pill);\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.live-share-badge::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--vb-danger);\n}\n\n.live-share-url {\n  flex: 1 1 160px;\n  min-width: 0;\n  min-height: 40px;\n  padding: 8px 10px;\n  border: 1px solid var(--vb-border);\n  border-radius: 10px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-size: 13px;\n}\n\n.live-share-copy {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  border: none;\n  padding: 8px 14px;\n}\n\n.live-share-stop {\n  background: transparent;\n  color: var(--vb-text-muted);\n  border: 1px solid var(--vb-border);\n  padding: 8px 12px;\n}\n\n.timeout-container {\n  display: contents;\n}\n\n.timeout-team-a,\n.timeout-team-b {\n  padding: 4px 6px;\n  font-size: 11px;\n  gap: 6px;\n}\n\n.timeout-checkbox {\n  width: 28px;\n  height: 28px;\n}\n\n.score-controls {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.score-controls button,\n.swap-colors-btn,\n.reset-btn {\n  min-height: 36px;\n  min-width: 36px;\n  padding: 6px 10px;\n  font-size: 13px;\n}\n\n.quiet-details {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 10px;\n  padding: 0 12px;\n}\n\n.quiet-details summary {\n  cursor: pointer;\n  list-style: none;\n  padding: 10px 0;\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.quiet-details summary::-webkit-details-marker { display: none; }\n.quiet-details[open] summary { color: var(--vb-text); }\n.quiet-details .note-field { padding-bottom: 10px; }\n\n.team-input-container {\n  position: relative;\n}\n\n.team-inputs input,\n.team-input {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 16px;\n  box-sizing: border-box;\n  border-radius: var(--vb-radius-sm);\n  border: 2px solid var(--vb-border);\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-weight: 650;\n}\n\n.team-a-input { border-color: var(--vb-team-a); }\n.team-b-input { border-color: var(--vb-team-b); }\n\n.team-input:disabled {\n  background: var(--vb-surface-2);\n  color: var(--vb-text-muted);\n  cursor: not-allowed;\n}\n\n.team-inputs .suggestions {\n  position: absolute;\n  top: calc(100% - 2px);\n  left: 0;\n  right: 0;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 0 0 12px 12px;\n  z-index: 20;\n  max-height: 200px;\n  overflow-y: auto;\n  box-shadow: var(--vb-shadow);\n}\n\n.team-inputs .suggestion-item {\n  padding: 10px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--vb-border);\n  color: var(--vb-text);\n  font-size: 14px;\n}\n\n.team-inputs .suggestion-item:hover {\n  background: var(--vb-surface-hover);\n}\n\n.team-inputs .suggestion-item:last-child { border-bottom: none; }\n\n/* Match group */\n.match-group-selector {\n  background: transparent;\n  border: none;\n  padding: 0;\n  box-shadow: none;\n}\n\n.match-group-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  font-weight: 650;\n  font-size: 13px;\n  color: var(--vb-text-muted);\n}\n\n.current-match-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  padding: 6px 10px;\n  border-radius: 10px;\n  color: var(--vb-text);\n  font-size: 13px;\n}\n\n.set-number {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  padding: 2px 8px;\n  border-radius: var(--vb-radius-pill);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.clear-match-btn {\n  background: transparent;\n  color: inherit;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.match-group-select,\n.new-match-form input,\n.new-match-form select,\n.form-row input,\n.form-row select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-sm);\n  font-size: 14px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  box-sizing: border-box;\n}\n\n.new-match-form {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--vb-border);\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.create-btn,\n.cancel-btn {\n  border: none;\n  padding: 10px 16px;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.create-btn { background: var(--vb-success); color: #fff; }\n.cancel-btn { background: var(--vb-surface-2); color: var(--vb-text); border: 1px solid var(--vb-border); }\n\n@media (max-width: 768px) {\n  .form-row { grid-template-columns: 1fr; }\n}\n\n/* Live score panels */\n.live-scoreboard-wrap {\n  position: relative;\n}\n\n.live-scoreboard {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  align-items: stretch;\n}\n\n.timeout-clock {\n  position: absolute;\n  inset: 0;\n  z-index: 6;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 20px;\n  border-radius: var(--vb-radius-lg);\n  background: rgba(15, 23, 42, 0.9);\n  color: #fff;\n  text-align: center;\n  box-shadow: var(--vb-shadow-lg);\n}\n\n.timeout-clock.team-a {\n  background: color-mix(in srgb, var(--vb-team-a) 86%, #0f172a);\n}\n\n.timeout-clock.team-b {\n  background: color-mix(in srgb, var(--vb-team-b) 86%, #0f172a);\n}\n\n.timeout-clock-kicker {\n  display: block;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  opacity: 0.8;\n}\n\n.timeout-clock-team {\n  display: block;\n  margin-top: 2px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.timeout-clock-time {\n  font-family: var(--vb-font-score);\n  font-size: clamp(3.4rem, 16vw, 5.6rem);\n  font-weight: 800;\n  line-height: 0.9;\n  letter-spacing: -0.03em;\n  font-variant-numeric: tabular-nums;\n  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n}\n\n.timeout-clock.ending .timeout-clock-time {\n  color: #fbbf24;\n}\n\n.timeout-clock.expired .timeout-clock-time {\n  color: #fbbf24;\n  letter-spacing: 0.08em;\n}\n\n.timeout-clock-track {\n  width: min(72%, 260px);\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.22);\n  overflow: hidden;\n}\n\n.timeout-clock-fill {\n  height: 100%;\n  width: 100%;\n  transform-origin: left center;\n  background: #fff;\n  transition: transform 1s linear;\n}\n\n.timeout-clock.ending .timeout-clock-fill {\n  background: #fbbf24;\n}\n\n.timeout-clock-dismiss {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  padding: 8px 14px;\n  border: 1.5px solid rgba(255, 255, 255, 0.55);\n  border-radius: var(--vb-radius-pill);\n  background: rgba(0, 0, 0, 0.28);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.timeout-clock-dismiss:hover {\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.live-scoreboard .team-panel,\n.live-scoreboard .team {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 140px;\n  padding: 26px 10px 40px;\n  border: none;\n  border-radius: var(--vb-radius-lg);\n  cursor: pointer;\n  color: #fff;\n  user-select: none;\n  overflow: hidden;\n  touch-action: manipulation;\n  box-shadow: var(--vb-shadow);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n}\n\n.live-scoreboard .team-panel:hover,\n.live-scoreboard .team:hover {\n  transform: translateY(-2px);\n  filter: brightness(1.06);\n}\n\n.live-scoreboard .team-panel:active,\n.live-scoreboard .team:active {\n  transform: scale(0.98);\n}\n\n.live-scoreboard .team-a {\n  background: linear-gradient(165deg, #fb7185 0%, var(--vb-team-a) 45%, var(--vb-team-a-deep) 100%);\n}\n\n.live-scoreboard .team-b {\n  background: linear-gradient(165deg, #60a5fa 0%, var(--vb-team-b) 45%, var(--vb-team-b-deep) 100%);\n}\n\n.serving-chip {\n  position: absolute;\n  top: 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: var(--vb-radius-pill);\n  background: var(--vb-serve);\n  color: #0b1d36;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  animation: none;\n}\n\n@keyframes serve-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.6); }\n  50% { box-shadow: 0 0 0 8px rgba(251, 191, 36, 0); }\n}\n\n.live-scoreboard .team-name {\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  opacity: 0.92;\n  text-align: center;\n  max-width: 100%;\n  word-break: break-word;\n}\n\n.live-scoreboard .score {\n  font-family: var(--vb-font-score);\n  font-size: clamp(3.4rem, 13vw, 5.2rem);\n  font-weight: 800;\n  line-height: 0.9;\n  letter-spacing: -0.04em;\n  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n}\n\n.tap-hint {\n  margin-top: 8px;\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 0.75;\n}\n\n.board-center {\n  display: none;\n}\n\n.vs-label {\n  font-family: var(--vb-font-score);\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.serve-hint {\n  font-size: 10px;\n  text-align: center;\n  max-width: 64px;\n  line-height: 1.3;\n}\n\n.serving-indicator {\n  display: none;\n}\n\n@keyframes flash-team-a {\n  0%, 100% { filter: brightness(100%); }\n  50% { filter: brightness(130%); }\n}\n@keyframes flash-team-b {\n  0%, 100% { filter: brightness(100%); }\n  50% { filter: brightness(125%); }\n}\n\n.live-scoreboard .team-a.flash { animation: flash-team-a 0.3s ease-out; }\n.live-scoreboard .team-b.flash { animation: flash-team-b 0.3s ease-out; }\n\n.ace-btn {\n  position: absolute;\n  bottom: 8px;\n  z-index: 2;\n  min-width: 40px;\n  min-height: 26px;\n  padding: 3px 8px;\n  border: 1.5px solid rgba(255, 255, 255, 0.5);\n  border-radius: var(--vb-radius-pill);\n  background: rgba(0, 0, 0, 0.32);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  cursor: pointer;\n  touch-action: manipulation;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n}\n\n.ace-btn-left { left: 8px; }\n.ace-btn-right { right: 8px; }\n\n.ace-btn:hover {\n  background: rgba(0, 0, 0, 0.5);\n  border-color: #fbbf24;\n  color: #fbbf24;\n}\n\n.ace-btn:active {\n  transform: scale(0.94);\n  background: #fbbf24;\n  border-color: #fbbf24;\n  color: #0b1d36;\n}\n\n.ace-btn:focus-visible {\n  outline: 2px solid #fbbf24;\n  outline-offset: 2px;\n}\n\n/* Timeouts */\n.timeout-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n  width: 100%;\n}\n\n.timeout-team-a,\n.timeout-team-b {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.timeout-checkbox {\n  position: relative;\n  display: inline-block;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.timeout-checkbox input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.checkbox-custom {\n  position: absolute;\n  inset: 0;\n  background: var(--vb-surface-2);\n  border: 2px solid var(--vb-border-strong);\n  border-radius: 10px;\n  transition: all 0.2s ease;\n}\n\n.timeout-team-a .checkbox-custom { border-color: var(--vb-team-a); }\n.timeout-team-b .checkbox-custom { border-color: var(--vb-team-b); }\n\n.timeout-checkbox input:checked + .checkbox-custom::after {\n  content: 'T';\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  font-size: 14px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.timeout-team-a input:checked + .checkbox-custom {\n  background: var(--vb-team-a);\n  border-color: var(--vb-team-a);\n}\n.timeout-team-b input:checked + .checkbox-custom {\n  background: var(--vb-team-b);\n  border-color: var(--vb-team-b);\n}\n\n/* Controls */\n.score-controls {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.score-controls button,\n.swap-colors-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 44px;\n  padding: 8px 12px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-weight: 650;\n  font-size: 13px;\n}\n\n.score-controls button:hover,\n.swap-colors-btn:hover {\n  background: var(--vb-surface-hover);\n}\n\n.score-controls .button-a,\n.score-controls .button-b {\n  max-width: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.reset-control {\n  display: flex;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.reset-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  border: 1px solid color-mix(in srgb, var(--vb-danger) 30%, transparent);\n  padding: 10px 18px;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.reset-btn:hover { filter: brightness(0.95); }\n\n/* Notes + messages */\n.note-field {\n  width: 100%;\n  max-width: 100%;\n}\n\n.note-field textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 14px;\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  resize: vertical;\n  font-size: 16px;\n  min-height: 80px;\n}\n\n.message-container {\n  min-height: 0;\n}\n\n.error-message,\n.success-message {\n  padding: 10px 12px;\n  border-radius: var(--vb-radius-sm);\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.error-message {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n}\n.success-message {\n  background: var(--vb-success-soft);\n  color: var(--vb-success);\n}\n\n/* Rally table + chart */\n.scoring-order-table {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  padding: 14px;\n  box-shadow: var(--vb-shadow-sm);\n}\n\n.scoring-order-table h3 {\n  text-align: center;\n  margin: 0 0 10px;\n  font-size: 14px;\n  color: var(--vb-text-muted);\n}\n\n.scoring-order-table table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n.scoring-order-table th,\n.scoring-order-table td {\n  border: none;\n  padding: 8px;\n  text-align: center;\n  vertical-align: top;\n}\n\n.scoring-order-table th {\n  background: transparent;\n  color: var(--vb-text);\n  font-size: 13px;\n}\n\n.scoring-order-table td {\n  height: auto;\n  min-height: 64px;\n}\n\n.scoring-order-table .score-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  margin: 2px;\n  border-radius: 8px;\n  background: var(--vb-surface-2);\n  border: 1px solid var(--vb-border);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.scoring-order-table .timeout-item {\n  background: var(--vb-warning);\n  color: #0b1d36;\n  border-color: transparent;\n}\n\n.scoring-order-table .ace-item {\n  min-width: 32px;\n  width: auto;\n  padding: 0 4px;\n  background: #fbbf24;\n  color: #0b1d36;\n  border-color: transparent;\n}\n\n.score-chart {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  padding: 14px;\n  box-shadow: var(--vb-shadow-sm);\n}\n\n.score-chart h3,\n.score-chart h4 {\n  text-align: center;\n  margin: 0 0 12px;\n  font-size: 14px;\n  color: var(--vb-text);\n}\n\n/* Recent matches */\n.recent-matches-container {\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto 40px;\n  padding: 0 12px;\n  box-sizing: border-box;\n}\n\n.recent-matches {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  padding: 16px;\n  box-shadow: var(--vb-shadow-sm);\n}\n\n.recent-matches h2 {\n  text-align: left;\n  text-transform: none;\n  letter-spacing: -0.02em;\n  font-size: 16px;\n  font-weight: 800;\n  margin: 0 0 12px;\n  color: var(--vb-text);\n}\n\n.recent-match-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.recent-match-card {\n  display: grid;\n  grid-template-columns: 88px 1fr auto;\n  gap: 10px;\n  align-items: center;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--vb-surface-2);\n  border: 1px solid transparent;\n}\n\n.recent-match-card:hover {\n  border-color: var(--vb-border);\n}\n\n.rm-date {\n  font-size: 12px;\n  color: var(--vb-text-muted);\n  font-weight: 600;\n}\n\n.rm-teams {\n  font-size: 14px;\n  color: var(--vb-text);\n}\n\n.rm-score {\n  font-family: var(--vb-font-score);\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.winner { font-weight: 800; color: var(--vb-primary); }\n\n.recent-matches table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.recent-matches th,\n.recent-matches td {\n  border: none;\n  border-bottom: 1px solid var(--vb-border);\n  padding: 10px 8px;\n  text-align: left;\n  color: var(--vb-text);\n}\n\n.recent-matches tbody tr:last-child td { border-bottom: none; }\n.recent-matches tbody tr:hover { background: var(--vb-surface-hover); }\n\n.recent-matches th {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--vb-text-muted);\n}\n\n.note-cell {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (min-width: 768px) {\n  .game-area { max-width: 760px; }\n  .live-scoreboard .team-panel, .live-scoreboard .team { min-height: 168px; }\n  .live-scoreboard .score { font-size: 5.5rem; }\n}\n\n@media (max-width: 480px) {\n  .live-scoreboard { gap: 6px; }\n  .board-center { min-width: 28px; }\n  .vs-label { font-size: 14px; }\n  .tap-hint { display: none; }\n  .team-name { font-size: 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
